import React from 'react'

import { Route, Redirect } from 'react-router-dom'
import Authentication from '../shared/services/authentication'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = Authentication.isAuthenticated
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...rest} {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )
}
export default PrivateRoute
